module.exports = __webpack_public_path__ + "img/paris.6e106e94.png";